// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"082d6b6b","455":"229d75de","977":"a0d9ec84"}[chunkId] + ".chunk.js";
};